












import { RouterNames } from "@/router/routernames";
import { Usuario } from "@/shared/dtos/usuario";
import { MessageService } from "@/shared/services/message-service";
import usuarioModule from "@/store/modules/usuario-module";
import { UtilsString } from "@/utils/utils-string";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    DynamicTable: () => import("@/views/dynamic_tables/dynamic_table.vue"),
  },
})
export default class UsuariosLista extends Vue {
  nuevo() {
    this.abrir_formulario("-1");
  }

  editar(user: Usuario) {
    this.abrir_formulario(UtilsString.ValueOf(user.id));
  }

  eliminar(user: Usuario) {
    usuarioModule
      .eliminarusuario(user)
      .then(() => {
        //@ts-ignore
        this.$refs["data_table"].refresh();
      })
      .catch(() => {
        MessageService.toast(
          "No se ha podido eliminar, hay datos asociados a este usuario",
          MessageService.TypeWarning
        );
      });
  }

  abrir_formulario(id_user: string) {
    this.$router.push({
      name: RouterNames.usuariosformulario,
      params: { id: id_user },
    });
  }
}
